import { render } from "./ReferencesTable.vue?vue&type=template&id=cebbab1a&scoped=true"
import script from "./ReferencesTable.vue?vue&type=script&lang=js"
export * from "./ReferencesTable.vue?vue&type=script&lang=js"

import "./ReferencesTable.vue?vue&type=style&index=0&id=cebbab1a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebbab1a"]])

export default __exports__